<template>
    <div class="loginContent">
        <div class="loginMask"></div>
        <div class="webLogoBox flex">
            <el-image v-if="webData.logo" :src="webData.logo" fit="cover" class="webLogo"></el-image>
            <div class="webName">{{ webData.name }}</div>
        </div>
        <div class="loginPopup">
            <div class="tabBox flex">
                <div :class="['tab',active == index ? 'tabOn' : '']" v-for="(item,index) in tabData" :key="index" @click="tabTap(index)">{{ item }}</div>
            </div>
            <div :class="['loginFlex align',phoneB ? 'loginFlexB' : phoneF ? 'loginFlexF' : '']">
                <div class="area">+86</div>
                <el-input placeholder="请输入手机号" v-model="phone" maxlength="11" class="phoneIpt" @focus="phoneFocus" @blur="phoneBlur"></el-input>
            </div>
            <div class="iptTips">{{ phoneTips }}</div>
            <template v-if="active == '0'">
                <div :class="['loginFlex align',codeB ? 'loginFlexB' : codeF ? 'loginFlexF' : '']">
                    <el-input placeholder="请输入验证码" v-model="code" class="codeIpt" @focus="codeFocus" @blur="codeBlur"></el-input>
                    <div class="codeBtn" :style="{color: gain ? '#0F59FE' : '#c6c6c6',cursor: gain ? 'pointer' : 'default'}" @click="codeBtnTap">{{ time == '0' ? '获取短信验证码' : time + 's后重新获取' }}</div>
                </div>
                <div class="iptTips">{{ codeTips }}</div>
            </template>
            <template v-if="active == '1'">
                <div :class="['loginFlex align',passB ? 'loginFlexB' : passF ? 'loginFlexF' : '']">
                    <el-input placeholder="请输入密码" v-model="pass" class="codeIpt" @focus="passFocus" @blur="passBlur"></el-input>
                </div>
                <div class="spb" style="width: 336px;">
                    <div class="iptTips" style="flex: 1;">{{passTips}}</div>
                    <div class="forget" @click="forgetTap">忘记密码？</div>
                </div>
            </template>
            <div class="loginBtn" @click="loginBtnTap">登录</div>
            <div class="loginTips">登录即表示同意<span>《用户注册协议》</span><span>《用户隐私协议》</span></div>
            <div class="registerBtn" @click="registerBtnTap">免费注册</div>
        </div>
        <div class="filingsBox">
            <div class="filingsList">
                <div class="filings" v-for="(item,index) in webData.bottom" :key="index" @click="filingsTap(item.url)">{{ item.name }}&nbsp;</div>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        data(){
            return{
                tabData: ['验证码登录','密码登录'],
                active: 0,
                phone: '',
                phoneTips: '',
                phoneF: false,
                phoneB: false,
                code: '',
                codeTips: '',
                codeF: false,
                codeB: false,
                pass: '',
                passTips: '',
                passF: false,
                passB: false,
                gain: true,
                time: 0,
                webData: {}
            }
        },
        mounted(){
            this.getIndexCategory()
        },
        methods: {
             // 获取网站名称
             getIndexCategory(){
                this.request.get("index/index/basic",{
                    params:{
                       
                    }
                })
                .then(res=>{
                    this.webData = res.data
                })
            },
            // tab切换
            tabTap(e){
                this.active = e
                this.phoneTips = this.codeTips = this.passTips = ''
                this.phoneB = this.phoneF = this.codeB = this.codeF = this.passB = this.passF = false
            },
            // 手机号获得焦点
            phoneFocus(){
                this.phoneF = true
            },
            // 手机号失去焦点
            phoneBlur(){
                this.phoneF = false
                let tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
                this.phoneTips = !tel.test(this.phone) ? '请输入正确的手机号' : ''
                this.phoneB = !tel.test(this.phone) ? true : false
                return this.phoneTips
            },
            // 验证码获得焦点
            codeFocus(){
                this.codeF = true
            },
            // 验证码失去焦点
            codeBlur(){
                this.codeF = false
                this.codeTips = this.code == '' ? '请输入验证码' : ''
                this.codeB = this.code == '' ? true : false
                return this.codeTips
            },
            // 密码获得焦点
            passFocus(){
                this.passF = true
            },
            // 密码失去焦点
            passBlur(){
                this.passF = false
                this.passTips = this.pass == '' ? '请输入密码' : ''
                this.passB = this.pass == '' ? true : false
                return this.passTips
            },
            // 获取验证码
            codeBtnTap(){
                var that = this
                if(that.gain && that.phoneBlur() == ''){
                    this.request.get("api/common/sendSms",{
                        params:{
                            mobile: that.phone,
                            timeStamp: parseInt(new Date().getTime() / 1000)
                        }
                    })
                    .then(res=>{
                        if(res.code){
                            that.time = 60
                            that.gain = false
                            var count = setInterval(function(){
                                that.time--
                                if(that.time == 0){
                                    that.gain = true
                                    clearInterval(count)
                                }
                            },1000)
                        }else{
                            that.$message.error(res.msg);
                        }
                        
                    })
                }
            },
            // 登录
            loginBtnTap(){
                if(this.active == '0' && this.phoneBlur() == '' && this.codeBlur() == ''){
                    this.request.get("index/user/login",{
                        params:{
                            mobile: this.phone,
                            code: this.code
                        }
                    })
                    .then(res=>{
                        if(res.code){
                            localStorage.setItem('userInfo',JSON.stringify(res.data))
                            this.$message({
                                message: '登录成功',
                                type: 'success'
                            });
                            setTimeout(()=>{
                                this.$router.go(-1)
                            },1000)
                        }else{
                            this.$message.error(res.msg);
                        }
                    })
                }
                if(this.active == '1' && this.phoneBlur() == '' && this.passBlur() == ''){
                    this.request.get("index/user/login",{
                        params:{
                            mobile: this.phone,
                            password: this.pass
                        }
                    })
                    .then(res=>{
                        if(res.code){
                            localStorage.setItem('userInfo',JSON.stringify(res.data))
                            this.$message({
                                message: '登录成功',
                                type: 'success'
                            });
                            setTimeout(()=>{
                                this.$router.go(-1)
                            },1000)
                        }else{
                            this.$message.error(res.msg);
                        }
                    })
                }
            },
            // 跳转注册
            registerBtnTap(){
                this.$router.push({ path:'/login/register' })
            },
            // 跳转忘记密码
            forgetTap(){
                this.$router.push({ path:'/login/forget' })
            }
        }
    }
</script>
<style lang="less" scoped>
    @import '../../common/css/login.less';
</style>